import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-imagens',
  standalone: true,
  imports: [CommonModule, MatDialogModule], 
  templateUrl: './imagens.component.html',
  styleUrl: './imagens.component.scss'
})
export class ImagensComponent {
  imagens: string[];
  selectedImageIndex: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ImagensComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imagens: string[] }
  ) {
    this.imagens = data.imagens;
  }

  fecharModal() {
    this.dialogRef.close();
  }

  avancar() {
    this.selectedImageIndex = (this.selectedImageIndex + 1) % this.imagens.length;
  }

  voltar() {
    this.selectedImageIndex = (this.selectedImageIndex - 1 + this.imagens.length) % this.imagens.length;
  }
  selecionarImagem(index: number) {
    this.selectedImageIndex = index;
  }
  
}